import React, { FC } from 'react';
import { Footer } from 'antd/lib/layout/layout';

import './styles.scss';

const CopyRight: FC = () => {
  return (
    <Footer className="cvta-copyright">
      <div className="copyright__text">
        {`Copyright ${new Date().getFullYear()} by `}
        <a rel="noreferrer" href="https://clik.vn" target="_blank">
          Clik
        </a>
        . All Rights Reserved.
      </div>
    </Footer>
  );
};

export default CopyRight;
